<template>
    <div class="row">
        <div class="col-md-6">
            <account-data></account-data>
        </div>
        <div class="col-md-6">
            <change-password></change-password>
        </div>
    </div>
</template>

<script>
    import AccountData from './account/AccountData'
    import ChangePassword from './account/ChangePassword'

    export default {
    
        components: {
            AccountData, ChangePassword
        }
    }
</script>
